export const HcpProgramEnum = {
    RESEARCH: 0,
    RESPIRATORY: 1,
    CARDIO: 2,
};
